import { Box, styled } from '@material-ui/core';
import { QRCodeSVG } from 'qrcode.react';

export const SuccessContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: 32,
  textAlign: 'center',
  paddingLeft: 24,
  paddingRight: 24,
});

export const IllustrationWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  width: 184,
  height: 184,
  background: 'color-mix(in srgb, #F9CAC9 32%, transparent)',
  borderRadius: '50%',
  marginBottom: 16,
});

export const Illustration = styled('img')({
  width: 96,
});

export const StoreBadgeContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 16,
  marginTop: 24,
});

export const StoreBadgeLink = styled('a')({
  display: 'inline-block',
  '& img': {
    height: 48,
  },
});

export const QRCodeWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  margin: '0 16px',
  marginTop: 24,
});

export const QRCode = styled(QRCodeSVG)({
  marginBottom: 16,
});
